module.exports = __webpack_public_path__ + "img/incidence-other-check.36d6fa33.svg";